import { normalize } from 'normalizr'
import { pathOr } from 'ramda'
import { arrayOfRates } from '../../rateSchema'

export default rates => {
    const ratesData = pathOr([], ['_embedded', 'expediaRates'], rates)
    return { ...normalize(ratesData, arrayOfRates) }
}



// WEBPACK FOOTER //
// ./src/adapters/parsers/expediaParsers/expediaRates.js